// Provincias y ciudades/barrios válidas para la API de sucursales de MercadoPago Argentina.
// Fuente: GET https://api.mercadopago.com/v1/countries/AR (provincias)
//         GET https://api.mercadolibre.com/classified_locations/states/{id} (ciudades)
//         GET https://api.mercadolibre.com/classified_locations/cities/TUxBQ0NBUGZlZG1sYQ (barrios CABA)
// Capital Federal usa barrios (neighborhoods) como city_name — no "Capital Federal".
// Buenos Aires incluye Interior + GBA Norte/Sur/Oeste + Costa Atlántica.

export const MP_PROVINCES = [
  'Buenos Aires',
  'Capital Federal',
  'Catamarca',
  'Chaco',
  'Chubut',
  'Corrientes',
  'Córdoba',
  'Entre Ríos',
  'Formosa',
  'Jujuy',
  'La Pampa',
  'La Rioja',
  'Mendoza',
  'Misiones',
  'Neuquén',
  'Río Negro',
  'Salta',
  'San Juan',
  'San Luis',
  'Santa Cruz',
  'Santa Fe',
  'Santiago del Estero',
  'Tierra del Fuego',
  'Tucumán',
];

export const MP_CITIES = {
  'Buenos Aires': [
    '25 de Mayo',
    '9 de Julio',
    'Adolfo Alsina',
    'Adolfo Gonzales Chaves',
    'Aguas Verdes',
    'Alberti',
    'Almirante Brown',
    'Arrecifes',
    'Avellaneda',
    'Ayacucho',
    'Azul',
    'Bahía Blanca',
    'Balcarce',
    'Baradero',
    'Beccar',
    'Benito Juárez',
    'Berazategui',
    'Berisso',
    'Bolívar',
    'Bragado',
    'Brandsen',
    'Campana',
    'Capitán Sarmiento',
    'Cariló',
    'Carlos Casares',
    'Carlos Tejedor',
    'Carmen de Areco',
    'Caseros',
    'Castelar',
    'Castelli',
    'Cañuelas',
    'Chacabuco',
    'Chapadmalal',
    'Chascomús',
    'Chivilcoy',
    'Colón',
    'Coronel Dorrego',
    'Coronel Pringles',
    'Coronel Rosales',
    'Coronel Suárez',
    'Costa Azul',
    'Costa Chica',
    'Costa Esmeralda',
    'Costa del Este',
    'Daireaux',
    'Del Viso',
    'Dolores',
    'Ensenada',
    'Escobar',
    'Esteban Echeverría',
    'Exaltación de la Cruz',
    'Ezeiza',
    'Florencio Varela',
    'Florentino Ameghino',
    'General Alvarado',
    'General Alvear',
    'General Arenales',
    'General Belgrano',
    'General Daniel Cerri',
    'General Guido',
    'General La Madrid',
    'General Las Heras',
    'General Lavalle',
    'General Madariaga',
    'General Paz',
    'General Pinto',
    'General Pueyrredón',
    'General Rodríguez',
    'General San Martín',
    'General Viamonte',
    'General Villegas',
    'Guaminí',
    'Hipólito Yrigoyen',
    'Hurlingham',
    'Ituzaingó',
    'José C. Paz',
    'Junín',
    'La Lucila del Mar',
    'La Matanza',
    'La Plata',
    'Lanús',
    'Laprida',
    'Las Flores',
    'Las Toninas',
    'Leandro N. Alem',
    'Lezama',
    'Lincoln',
    'Lobería',
    'Lobos',
    'Lomas de Zamora',
    'Los Cardales',
    'Luján',
    'Magdalena',
    'Maipú',
    'Malvinas Argentinas',
    'Mar Azul',
    'Mar Chiquita',
    'Mar De Cobo',
    'Mar de Ajo',
    'Mar de las Pampas',
    'Mar del Plata',
    'Mar del Sur',
    'Mar del Tuyú',
    'Marcos Paz',
    'Mercedes',
    'Merlo',
    'Miramar',
    'Monte',
    'Monte Hermoso',
    'Moreno',
    'Morón',
    'Navarro',
    'Necochea',
    'Nueva Atlantis',
    'Nueva Zelaya',
    'Olavarría',
    'Ostende',
    'Patagones',
    'Pehuajó',
    'Pellegrini',
    'Pergamino',
    'Pila',
    'Pilar',
    'Pinamar',
    'Presidente Perón',
    'Punta Indio',
    'Punta Médanos',
    'Puán',
    'Quilmes',
    'Ramallo',
    'Ranchos',
    'Rauch',
    'Rivadavia',
    'Rojas',
    'Roque Pérez',
    'Saavedra',
    'Saladillo',
    'Salliqueló',
    'Salto',
    'San Andrés de Giles',
    'San Antonio de Areco',
    'San Bernardo',
    'San Cayetano',
    'San Clemente',
    'San Fernando',
    'San Isidro',
    'San Miguel',
    'San Nicolás',
    'San Pedro',
    'San Vicente',
    'Santa Clara del Mar',
    'Santa Teresita',
    'Suipacha',
    'Tandil',
    'Tapalqué',
    'Tigre',
    'Tordillo',
    'Tornquist',
    'Trenque Lauquen',
    'Tres Arroyos',
    'Tres Lomas',
    'Tres de febrero',
    'Valeria del Mar',
    'Verónica',
    'Vicente López',
    'Villa Gesell',
    'Villa Robles',
    'Villarino',
    'Zelaya',
    'Zárate',
  ],
  'Capital Federal': [
    'Agronomía',
    'Almagro',
    'Balvanera',
    'Barracas',
    'Barrio Norte',
    'Belgrano',
    'Belgrano Barrancas',
    'Belgrano C',
    'Belgrano Chico',
    'Belgrano R',
    'Boedo',
    'Botánico',
    'Caballito',
    'Chacarita',
    'Coghlan',
    'Colegiales',
    'Congreso',
    'Constitución',
    'Flores',
    'Floresta',
    'La Boca',
    'Las Cañitas',
    'Liniers',
    'Mataderos',
    'Monserrat',
    'Monte Castro',
    'Nueva Pompeya',
    'Núñez',
    'Once',
    'Palermo',
    'Palermo Chico',
    'Palermo Hollywood',
    'Palermo Nuevo',
    'Palermo Soho',
    'Palermo Viejo',
    'Parque Avellaneda',
    'Parque Centenario',
    'Parque Chacabuco',
    'Parque Chas',
    'Parque Patricios',
    'Paternal',
    'Puerto Madero',
    'Puerto Retiro',
    'Recoleta',
    'Retiro',
    'Saavedra',
    'San Cristóbal',
    'San Nicolás',
    'San Telmo',
    'Santa Rita',
    'Velez Sarsfield',
    'Versalles',
    'Villa Crespo',
    'Villa Devoto',
    'Villa Gral. Mitre',
    'Villa Lugano',
    'Villa Luro',
    'Villa Ortúzar',
    'Villa Pueyrredón',
    'Villa Real',
    'Villa Riachuelo',
    'Villa Soldati',
    'Villa Urquiza',
    'Villa del Parque',
  ],
  'Catamarca': [
    'Ambato',
    'Ancasti',
    'Andalgalá',
    'Antofagasta de la Sierra',
    'Belén',
    'Capayán',
    'El Alto',
    'Fray Mamerto Esquiú',
    'La Paz',
    'Paclín',
    'Pomán',
    'San Fernando del Valle de Catamarca',
    'Santa María',
    'Santa Rosa',
    'Tinogasta',
    'Valle Viejo',
  ],
  'Chaco': [
    '12 de Octubre',
    '1º de Mayo',
    '2 de Abril',
    '25 de Mayo',
    '9 de Julio',
    'Almirante Brown',
    'Barranqueras',
    'Bermejo',
    'Chacabuco',
    'Comandante Fernández',
    'Fray Justo Santa María de Oro',
    'General Belgrano',
    'General Donovan',
    'General Güemes',
    'Independencia',
    'Libertad',
    'Libertador General San Martín',
    'Maipú',
    'Mayor Luis Jorge Fontana',
    'O Higgins',
    'Presidencia de la Plaza',
    'Quitilipi',
    'Resistencia',
    'Roque Saenz Peña',
    'San Lorenzo',
    'Sargento Cabral',
    'Tapenagá',
  ],
  'Chubut': [
    'Biedma',
    'Cushamen',
    'Escalante',
    'Florentino Ameghino',
    'Futaleufú',
    'Gaiman',
    'Gastre',
    'Languiñeo',
    'Mártires',
    'Paso de Indios',
    'Rawson',
    'Río Senguer',
    'Sarmiento',
    'Tehuelches',
    'Telsen',
  ],
  'Corrientes': [
    'Bella Vista',
    'Berón de Astrada',
    'Concepción',
    'Corrientes',
    'Curuzú Cuatiá',
    'Empedrado',
    'Esquina',
    'General Alvear',
    'General Paz',
    'Goya',
    'Itatí',
    'Ituzaingó',
    'Lavalle',
    'Mburucuyá',
    'Mercedes',
    'Monte Caseros',
    'Paso de la Patria',
    'Paso de los Libres',
    'Saladas',
    'San Cosme',
    'San Luis del Palmar',
    'San Martín',
    'San Miguel',
    'San Roque',
    'Santo Tomé',
    'Sauce',
  ],
  'Córdoba': [
    'Achiras',
    'Alta Gracia',
    'Arroyito',
    'Berrotarán',
    'Bialet Massé',
    'Calamuchita',
    'Colón',
    'Cosquín',
    'Cruz Alta',
    'Cruz del Eje',
    'Córdoba',
    'Freyre',
    'General Deheza',
    'General Roca',
    'General San Martín',
    'Ischilín',
    'Jesús María',
    'Juárez Celman',
    'La Bolsa',
    'La Calera',
    'La Carlota',
    'La Falda',
    'La Paisanita',
    'Laguna Larga',
    'Los Espinillos',
    'Malagueño',
    'Marcos Juárez',
    'Mendiolaza',
    'Minas',
    'Oncativo',
    'Ongamira',
    'Pocho',
    'Potrero de Garay',
    'Presidente Roque Sáenz Peña',
    'Puerto del Aguila',
    'Punilla',
    'Río Ceballos',
    'Río Cuarto',
    'Río Primero',
    'Río Seco',
    'Río Segundo',
    'San Alberto',
    'San Francisco',
    'San Javier',
    'San Justo',
    'Santa María',
    'Santa Rosa de Calamuchita',
    'Sobremonte',
    'Tercero Arriba',
    'Totoral',
    'Tulumba',
    'Unión',
    'Villa Allende',
    'Villa Carlos Paz',
    'Villa General Belgrano',
    'Villa María',
    'Villa Santa Rosa',
  ],
  'Entre Ríos': [
    'Aldea Protestante',
    'Aranguren',
    'Brazo Largo',
    'C. del Uruguay',
    'Colonia Ensayo',
    'Colonia Reffino',
    'Colón',
    'Concordia',
    'Costa Grande',
    'Crespo',
    'Diamante',
    'Federación',
    'Federal',
    'Feliciano',
    'Gualeguay',
    'Gualeguaychú',
    'Gualeguaycito',
    'Hernández',
    'Isla del Charigue',
    'Islas del Ibicuy',
    'La Paz',
    'Libertador San Martín',
    'María Grande',
    'María Luisa',
    'Nogoyá',
    'Paraná',
    'Puiggari',
    'Ramírez',
    'Rosario del Tala',
    'San Benito',
    'San Salvador',
    'Seguí',
    'Strobel',
    'Urdinarrain',
    'Viale',
    'Victoria',
    'Villaguay',
  ],
  'Formosa': [
    'Bermejo',
    'Formosa',
    'Laishi',
    'Matacos',
    'Patiño',
    'Pilagás',
    'Pilcomayo',
    'Pirané',
    'Puesto Aguara',
    'Ramón Lista',
  ],
  'Jujuy': [
    'Cochinoca',
    'Doctor Manuel Belgrano',
    'El Carmen',
    'Humahuaca',
    'Ledesma',
    'Palpalá',
    'Rinconada',
    'San Antonio',
    'San Pedro',
    'San Salvador de Jujuy',
    'Santa Bárbara',
    'Santa Catalina',
    'Susques',
    'Tilcara',
    'Tumbaya',
    'Valle Grande',
    'Yavi',
  ],
  'La Pampa': [
    'Atreucó',
    'Caleu Caleu',
    'Catriló',
    'Chalileo',
    'Chapaleufú',
    'Chical Co',
    'Conhelo',
    'Curacó',
    'Guatraché',
    'Hucal',
    'Lihuel Calel',
    'Limay Mahuida',
    'Loventué',
    'Maracó',
    'Puelén',
    'Quemú Quemú',
    'Rancul',
    'Realicó',
    'Santa Rosa',
    'Toay',
    'Trenel',
    'Utracán',
  ],
  'La Rioja': [
    'Arauco',
    'Castro Barros',
    'Chamical',
    'Chilecito',
    'Coronel Felipe Varela',
    'Famatina',
    'General Angel V. Peñaloza',
    'General Belgrano',
    'General Juan F. Quiroga',
    'General Lamadrid',
    'General Ocampo',
    'General San Martín',
    'Independencia',
    'La Rioja Capital',
    'Rosario Vera Peñaloza',
    'San Blas de los Sauces',
    'Sanagasta',
    'Vinchina',
  ],
  'Mendoza': [
    'General Alvear',
    'Godoy Cruz',
    'Guaymallén',
    'Junín',
    'La Paz',
    'Las Heras',
    'Lavalle',
    'Luján de Cuyo',
    'Maipú',
    'Malargüe',
    'Mendoza',
    'Rivadavia',
    'San Carlos',
    'San Martín',
    'San Rafael',
    'Santa Rosa',
    'Tunuyán',
    'Tupungato',
  ],
  'Misiones': [
    '25 de Mayo',
    'Apóstoles',
    'Cainguás',
    'Candelaria',
    'Concepción',
    'Eldorado',
    'Garupá',
    'General Manuel Belgrano',
    'Guaraní',
    'Iguazú',
    'Leandro N. Alem',
    'Libertador Grl. San Martín',
    'Montecarlo',
    'Oberá',
    'Posadas',
    'San Ignacio',
    'San Javier',
    'San Pedro',
  ],
  'Neuquén': [
    'Aluminé',
    'Arroyito',
    'Añelo',
    'Catán Lil',
    'Centenario',
    'Chos Malal',
    'Collón Curá',
    'Confluencia',
    'Cutral Có',
    'Huiliches',
    'Loncopué',
    'Los Lagos',
    'Lácar',
    'Minas',
    'Neuquén',
    'Pehuenches',
    'Picunches',
    'Picún Leufú',
    'Plottier',
    'Quila Quina',
    'San Martin de los Andes',
    'Senillosa',
    'Villa La Angostura',
    'Zapala',
    'Ñorquín',
  ],
  'Río Negro': [
    '25 de Mayo',
    '9 de Julio',
    'Avellaneda',
    'Bariloche',
    'Cinco Saltos',
    'Cipolletti',
    'Conesa',
    'El Bolsón',
    'El Cuy',
    'General Roca',
    'Pichi Mahuida',
    'Pilcaniyeu',
    'San Antonio',
    'Valcheta',
    'Viedma',
    'Ñorquincó',
  ],
  'Salta': [
    'Alfarcito',
    'Anta',
    'Cachi',
    'Cafayate',
    'Cerrillos',
    'Chaguaral',
    'Chicoana',
    'Coronel Juan Solá',
    'General Güemes',
    'Gral. José de San Martín',
    'Guachipas',
    'Iruya',
    'La Caldera',
    'La Candelaria',
    'La Poma',
    'La Viña',
    'Las Mojarritas',
    'Los Andes',
    'Metán',
    'Molinos',
    'Nueva Ceres',
    'Orán',
    'Rivadavia',
    'Rosario de Lerma',
    'Rosario de la Frontera',
    'Salta',
    'San Carlos',
    'San Lorenzo',
    'Santa Victoria',
  ],
  'San Juan': [
    '25 de Mayo',
    '9 de Julio',
    'Albardón',
    'Angaco',
    'Calingasta',
    'Caucete',
    'Chimbas',
    'Iglesia',
    'Jáchal',
    'Pocito',
    'Rawson',
    'Rivadavia',
    'San Juan Capital',
    'San Martín',
    'Santa Lucía',
    'Sarmiento',
    'Ullúm',
    'Valle Fértil',
    'Zonda',
  ],
  'San Luis': [
    'Ayacucho',
    'Belgrano',
    'Chacabuco',
    'Coronel Pringles',
    'General Pedernera',
    'Gobernador Dupuy',
    'Junín',
    'Libertador Gral. San Martín',
    'San Luis',
  ],
  'Santa Cruz': [
    'Corpen Aike',
    'Deseado',
    'Lago Argentino',
    'Lago Buenos Aires',
    'Magallanes',
    'Rio Turbio',
    'Río Chico',
    'Río Gallegos',
  ],
  'Santa Fe': [
    '9 de Julio',
    'Aldao',
    'Belgrano',
    'Caseros',
    'Castellanos',
    'Cerana',
    'Colonia Reina Margarita',
    'Constitución',
    'Coronel Rodolfo S. Domínguez',
    'Frontera',
    'Funes',
    'Garay',
    'General López',
    'General Obligado',
    'Granadero Baigorria',
    'Iriondo',
    'La Capital',
    'Las Colonias',
    'Rafaela',
    'Reconquista',
    'Roldán',
    'Rosario',
    'San Agustin',
    'San Carlos Norte',
    'San Carlos Sud',
    'San Cristóbal',
    'San Javier',
    'San Jerónimo',
    'San Jerónimo Sud',
    'San Justo',
    'San Lorenzo',
    'San Martín',
    'Santa Fe capital',
    'Santo Tomé',
    'Sauce Viejo',
    'Vera',
    'Villa La Ribera',
  ],
  'Santiago del Estero': [
    'Aguirre',
    'Alberdi',
    'Atamisqui',
    'Avellaneda',
    'Belgrano',
    'Choya',
    'Copo',
    'Figueroa',
    'General Taboada',
    'Guasayán',
    'Jiménez',
    'Juan F. Ibarra',
    'La Banda',
    'Loreto',
    'Moreno',
    'Pellegrini',
    'Pinto',
    'Quebrachos',
    'Rivadavia',
    'Robles',
    'Salavina',
    'San Martín',
    'Santiago del Estero',
    'Sarmiento',
    'Silípica',
    'Termas de Río Hondo',
    'Villa General Mitre',
    'Villa Ojo de Agua',
  ],
  'Tierra del Fuego': [
    'Río Grande',
    'Ushuaia',
  ],
  'Tucumán': [
    'Aguilares',
    'Burruyacú',
    'Chicligasta',
    'Cruz Alta',
    'Famaillá',
    'Graneros',
    'Juan Bautista Alberdi',
    'La Cocha',
    'Leales',
    'Lules',
    'Monteros',
    'Racó',
    'Río Chico',
    'San Miguel de Tucumán',
    'Simoca',
    'Tafí Viejo',
    'Tafí del Valle',
    'Trancas',
    'Yerba Buena',
  ],
};

/** Devuelve array de ciudades para la provincia, o null si no hay lista validada. */
export function getCitiesForProvince(province) {
  return MP_CITIES[province] || null;
}
